export const CUSTOM_ATTR_SECTION_PREFIX = 'custom_attr:';
export const LEGACY_CUSTOM_ATTR_SECTION_KEY = 'custom_attributes';

export const isCustomAttrSectionKey = key =>
  key.startsWith(CUSTOM_ATTR_SECTION_PREFIX);

export const customAttrSectionKey = category =>
  `${CUSTOM_ATTR_SECTION_PREFIX}${category}`;

export const categoryFromSectionKey = key =>
  key.slice(CUSTOM_ATTR_SECTION_PREFIX.length);
